import React, { useState, useEffect } from 'react'
import FacebookShareButton from 'react-share/lib/FacebookShareButton'
import FacebookIcon from 'react-share/lib/FacebookIcon'
import TwitterShareButton from 'react-share/lib/TwitterShareButton'
import TwitterIcon from 'react-share/lib/TwitterIcon'
import WhatsappShareButton from 'react-share/lib/WhatsappShareButton'
import WhatsappIcon from 'react-share/lib/WhatsappIcon'
import LinkedinShareButton from 'react-share/lib/LinkedinShareButton'
import LinkedinIcon from 'react-share/lib/LinkedinIcon'
import hideMessage from '../hidemessage';

//import your fontawesome icons here
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThumbsUp as faThumbsUpRegular } from '@fortawesome/free-regular-svg-icons'
import { faThumbsUp as faThumbsUpSolid, faShare, faTimes, faCopy } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faTwitter, faWhatsapp, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'

const isBrowser = () => typeof window !== "undefined"

export default function ShareButtons(props) {

  const [width, setWidth] = useState(0)
  const [share_icon, setShareIcon] = useState('')
  const [social_media_icon, setSocialMediaIcon] = useState('d-none')
  const [shareBtn, setShareBtn] = useState(true)

  useEffect(() => {
    if (isBrowser()) {
      setWidth(window.innerWidth);
      const handleResize = () => setWidth(window.innerWidth)
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);
  const displayShareIcon = e => {
    e.preventDefault();e.stopPropagation()
    if (e.target) {
      setShareIcon('d-none');setSocialMediaIcon('d-flex')
    }
  }
  const closeShareIcon = e => {
    e.preventDefault();e.stopPropagation()
    if (e.target) {
      setShareIcon('');setSocialMediaIcon('d-none')
    }
  }
  function shareWebcast(e) {
    e.preventDefault();e.stopPropagation()
    if (e.target) {
      setShareBtn(!shareBtn)
    }
  }
  const copyUrl = e => {
    e.preventDefault();e.stopPropagation()
    const select_url = document.createElement('textarea');
    select_url.value = props.url;
    select_url.setAttribute('readonly', '');
    select_url.style.position = 'absolute';
    select_url.style.left = '-9999px';
    document.body.appendChild(select_url);
    select_url.select();
    document.execCommand('copy');
    document.body.removeChild(select_url);
    hideMessage.displaySuccessMsg('Link copied to clipboard')
  }

  if (props.page_type === 'single_video_page') {
    if (width <= 980) {
      return (
        <React.Fragment>
          <FontAwesomeIcon className={`mr-1 pointer text-white`} icon={faCopy} onClick={(e) => {copyUrl(e)}} style={{width: '20px', height: '20px', padding: '6px', borderRadius: '50%', background: 'rgb(67, 169, 210)'}}/>
          <FacebookShareButton url={props.url} title={props.title} className="mr-1">
            <FacebookIcon size={20} round={true}/>
          </FacebookShareButton>
          <TwitterShareButton url={props.url} title={props.title} className="mr-1">
            <TwitterIcon size={20} round={true}/>
          </TwitterShareButton>
          <LinkedinShareButton url={props.url} title={props.title} summary={props.summary === undefined ? '' : props.summary} source="Leanpitch" className="mr-1">
            <LinkedinIcon size={20} round={true}/>
          </LinkedinShareButton>
          <WhatsappShareButton url={props.url} title={props.title}>
            <WhatsappIcon size={20} round={true}/>
          </WhatsappShareButton>
        </React.Fragment>
      )
    } else {
      return (
        <div className="text-right" style={{position: 'relative'}}>
          <FontAwesomeIcon className={`mr-2 pointer text-white`} icon={faCopy} onClick={(e) => {copyUrl(e)}} style={{width: '28px', height: '28px', padding: '6px', borderRadius: '50%', background: 'rgb(67, 169, 210)', position: 'absolute', left: '0'}}/>
          <FacebookShareButton url={props.url} title={props.title} className="mx-1">
            <FacebookIcon size={28} round={true}/>
          </FacebookShareButton>
          <TwitterShareButton url={props.url} title={props.title} className="mx-1">
            <TwitterIcon size={28} round={true}/>
          </TwitterShareButton>
          <LinkedinShareButton url={props.url} title={props.title} summary={props.summary === undefined ? '' : props.summary} source="Leanpitch" className="mx-1">
            <LinkedinIcon size={28} round={true}/>
          </LinkedinShareButton>
          <WhatsappShareButton url={props.url} title={props.title} className="mx-1">
            <WhatsappIcon size={28} round={true}/>
          </WhatsappShareButton>
        </div>
      );
    }
  }else if (props.page_type === 'video') {
    return (
      <div style={props.style}>
        <FontAwesomeIcon className={`mx-2 pointer ${share_icon}`} style={{margin: '0px 0px 0px -7px'}} icon={faShare} size="1x" onClick={(e) => {displayShareIcon(e)}}/>

        <div onClick={(e)=> {e.stopPropagation()} } className={`align-items-center ${social_media_icon}`} style={{marginTop: '2px'}}>
          <FontAwesomeIcon className={`mr-2 pointer`} icon={faTimes} size="sm" onClick={(e) => {closeShareIcon(e)}}/>
          <FontAwesomeIcon className={`mr-2 pointer`} icon={faCopy} size="1x" onClick={(e) => {copyUrl(e)}}/>
          <FacebookShareButton url={props.url} title={props.title} className="mr-2">
            <FacebookIcon size={28} round={true}/>
          </FacebookShareButton>
          <TwitterShareButton url={props.url} title={props.title} className="mr-2">
            <TwitterIcon size={28} round={true}/>
          </TwitterShareButton>
          <LinkedinShareButton url={props.url} title={props.title} summary={props.summary === undefined ? '' : props.summary} source="Leanpitch" className="mr-2">
            <LinkedinIcon size={28} round={true}/>
          </LinkedinShareButton>
          <WhatsappShareButton url={props.url} title={props.title} className="mr-2">
            <WhatsappIcon size={28} round={true}/>
          </WhatsappShareButton>
        </div>
      </div>
    );
  }else if (props.page_type === 'webcast') {
    return (
      <div style={{position: 'absolute', right: '15px', bottom: '15px'}} >
        <FontAwesomeIcon className={`mx-2 pointer ${shareBtn === true ? '' : 'd-none'}`} style={{fontSize: `18px`, marginLeft: '3px'}} icon={faShare} size="1x" onClick={(e) => {shareWebcast(e)}}/>
        <div onClick={(e)=> {e.stopPropagation()} } className={`${shareBtn === true ? 'd-none' : 'd-inline-block bg-white'}`}>
          <FontAwesomeIcon className={`pointer`} icon={faCopy} style={{fontSize: `14px` ,margin: `auto 3px`, color: `black`}} onClick={(e) => {copyUrl(e)}}/>
          <FacebookShareButton url={props.url} title={props.title} >
            <FontAwesomeIcon icon={faFacebookF} style={{fontSize: `14px` ,margin: `auto 3px`, color: `black`}} />
          </FacebookShareButton>
          <TwitterShareButton url={props.url} title={props.title} >
            <FontAwesomeIcon icon={faTwitter} style={{fontSize: `14px` ,margin: `auto 3px`, color: `black`}} />
          </TwitterShareButton>
          <WhatsappShareButton url={props.url} title={props.title} >
            <FontAwesomeIcon icon={faWhatsapp} style={{fontSize: `14px` ,margin: `auto 3px`, color: `black`}} />
          </WhatsappShareButton>
          <LinkedinShareButton url={props.url} title={props.title} summary={props.summary === undefined ? '' : props.summary} source="Leanpitch" >
            <FontAwesomeIcon icon={faLinkedinIn} style={{fontSize: `14px` ,margin: `auto 3px`, color: `black`}} />
          </LinkedinShareButton>
        </div>
        <FontAwesomeIcon onClick={(e) => shareWebcast(e)} className={`${shareBtn === true ? 'd-none' : ''} pointer`} icon={faTimes} style={{fontSize: `18px`, marginLeft: '3px'}} />
      </div>
    );
  }else {
    return (
      <div>
        <FontAwesomeIcon className="mx-2 pointer" style={{margin: '0px 0px 0px -7px', color:  props.type === 'solid' ? 'rgb(10 172 237)' : ''}} icon={props.type === 'solid' ? faThumbsUpSolid : faThumbsUpRegular} size="lg" onClick={props.onClick}/>

        <FacebookShareButton url={props.url.trim()} title={props.title.trim()} className="mr-2">
          <FacebookIcon size={32} round={true}/>
        </FacebookShareButton>

        <TwitterShareButton url={props.url.trim()} title={props.title.trim()} className="mr-2">
          <TwitterIcon size={32} round={true}/>
        </TwitterShareButton>

        <LinkedinShareButton url={props.url.trim()} title={props.title.trim()} summary={props.summary.trim()} source="Leanpitch" className="mr-2">
          <LinkedinIcon size={32} round={true}/>
        </LinkedinShareButton>

        <WhatsappShareButton url={props.url.trim()} title={props.title.trim()} className="mr-2">
          <WhatsappIcon size={32} round={true}/>
        </WhatsappShareButton>
      </div>
    );
  }
}
